const NICKNAME_KEY = "cw_nickname";
const RECONNECT_KEY = "cw_reconnect_token";
const ROOM_KEY = "cw_room_code";
const PLAYER_KEY = "cw_player_id";

export function getNickname(): string {
  return localStorage.getItem(NICKNAME_KEY) ?? "";
}

export function setNickname(nickname: string): void {
  localStorage.setItem(NICKNAME_KEY, nickname);
}

export function getReconnectToken(): string {
  return localStorage.getItem(RECONNECT_KEY) ?? "";
}

export function setReconnectToken(token: string): void {
  localStorage.setItem(RECONNECT_KEY, token);
}

export function getRoomCode(): string {
  return localStorage.getItem(ROOM_KEY) ?? "";
}

export function setRoomCode(code: string): void {
  localStorage.setItem(ROOM_KEY, code);
}

export function getPlayerId(): string {
  return localStorage.getItem(PLAYER_KEY) ?? "";
}

export function setPlayerId(id: string): void {
  localStorage.setItem(PLAYER_KEY, id);
}

export function clearSession(): void {
  localStorage.removeItem(RECONNECT_KEY);
  localStorage.removeItem(ROOM_KEY);
  localStorage.removeItem(PLAYER_KEY);
}
